// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".similar_qjQZ2{display:flex;justify-content:center;margin:2.4rem 0 0;padding-bottom:.4rem}.similar--empty_lUTjo{padding-bottom:3.2rem}.similar_qjQZ2 svg{height:2.4rem;width:2.4rem}.similar__btn_f7s0n{align-items:center;color:var(--cp-primary_main);display:flex;font-size:1.4rem;font-weight:400;height:auto;line-height:2rem;padding:0;-webkit-text-decoration:underline;text-decoration:underline}.similar__btn_f7s0n svg{margin-right:.8rem}.similar__btn_f7s0n.is_boutique_KxOFs{--cp-primary_main:var(--cp-black)}.similar__btn_f7s0n:hover{-webkit-text-decoration:none;text-decoration:none}.similar_qjQZ2.in_main_image_8Jbg0{margin:.8rem 0 0}.similar_qjQZ2.in_main_image_8Jbg0 .similar__btn_f7s0n{color:var(--cp-white)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"similar": "similar_qjQZ2",
	"similar--empty": "similar--empty_lUTjo",
	"similar__btn": "similar__btn_f7s0n",
	"is_boutique": "is_boutique_KxOFs",
	"in_main_image": "in_main_image_8Jbg0"
};
module.exports = ___CSS_LOADER_EXPORT___;
